import TreatmentDetail from "@/pages/treatment/components/TreatmentDetail";
import { getTreatmentPage } from "@/mocks/treatmentPages";

export default function EyePage() {
  const data = getTreatmentPage("eye");
  if (!data) return null;
  return (
    <TreatmentDetail
      data={data}
      monitorLp={{
        title: "初めての方限定・二重埋没法モニターのご案内",
        description:
          "初めてご来院いただく方向けの二重埋没法モニターの内容・条件は、専用ページでご案内しています。",
        label: "二重埋没法モニターを見る",
        url: "https://sbscl.biz/futae/",
      }}
    />
  );
}